export var LABEL_ADD_TO_BASKET_VISIBLE = 'AddToBasketVisible';
export var LABEL_CAN_BE_RESERVED = 'CanBeReserved';
export var LABEL_CAN_BE_SUBSCRIBED = 'CanBeSubscribed';
export var LABEL_DEAL = 'Deal';
export var LABEL_PPA = 'PPA';
//# sourceMappingURL=constants.js.map